type queryType = Record<string, string> | undefined;

export const generateModulePath = (
  inNextJs: boolean,
  projectBaseBath: string,
) => {
  return (path: string) => {
    return inNextJs ? path : `/${projectBaseBath}${path}`;
  };
};

export const pathGenerator = (path: string, query: queryType = undefined) => {
  if (!query) return path;
  const searchParams = new URLSearchParams(query);
  return `${path}?${searchParams.toString()}`;
};

export const parseHash = (url: string) => {
  const hashParams = new URLSearchParams(url.substring(1));

  const result: any = {};

  if (hashParams.toString() === '') return null;

  for (const [key, value] of hashParams) {
    result[key] = decodeURIComponent(value);
  }
  return result;
};

export const parseSearch = (url: string) => {
  const searchParams = new URLSearchParams(url);

  const result: any = {};

  if (searchParams.toString() === '') return null;

  for (const [key, value] of searchParams) {
    result[key] = decodeURIComponent(value);
  }
  return result;
};
